module.exports = __webpack_public_path__ + "img/智驹-APP介绍-中文_2_02.8d4f11e2.jpg";